import lottie from "lottie-web";

console.log('DotLottie loaded');
document.addEventListener("DOMContentLoaded", function(event){
  const mainLogo = lottie.loadAnimation({
    autoplay: true,
    loop: false,
    container: document.getElementById("main-logo"),
    renderer: "svg",
    path: "/lottie/vertNanaLogo.json",
    renderConfig: {
      autoResize: true,
    }
  });
  const description = lottie.loadAnimation({
    autoplay: false,
    loop: false,
    container: document.getElementById("logo-description"),
    renderer: "svg",
    path: "/lottie/vertNanaDescription.json",
    renderConfig: {
      autoResize: true,
    }
  });
  window.test = { lottie, mainLogo, description };
  const topLogo = lottie.loadAnimation({
    autoplay: false,
    loop: false,
    container: document.getElementById("top-logo"),
    renderer: "svg",
    path: "/lottie/vertNanaLogo.json",
    renderConfig: {
      autoResize: true,
    }
  });
  window.dotLottie = mainLogo;
  mainLogo.addEventListener('complete', () => {
    console.log('Main logo anim complete');
    document.dispatchEvent(new Event('logoAnimComplete'));
    topLogo.play();

    mainLogo.gotoFrame(75);
    mainLogo.setSpeed(3);
    mainLogo.setDirection(-1);
    mainLogo.play();

    setTimeout(() => {
      mainLogo.stop();
      description.play();
    }, 1200);
    document.getElementById("menu").style.opacity = 1;
  });
  // mainLogo.addEventListener('pause', () => {
    //     console.log('Pause');
  // });
  // mainLogo.addEventListener('stop', () => {
    //     console.log('Stop');
  // });
  // mainLogo.addEventListener('play', () => {
    //     console.log('Play');
  // });
  // mainLogo.addEventListener('frame', ({ currentFrame }) => {
    //     console.log('Current frame:', currentFrame);
  // });
});